import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';

interface PariPassuProps {
    deviationPercent: number;
    deviationAmount: number;
    currentBIDAmount: number;
    currentLocalAmount: number;
    contractualBIDAmount: number;
    contractualLocalAmount: number;
}

const PariPassuTable: React.FC<PariPassuProps> = ({ deviationPercent, deviationAmount, currentBIDAmount, currentLocalAmount, contractualBIDAmount, contractualLocalAmount }) => {
    const { t } = useTranslation();
    const { formatNumber } = useNumberFormatter();

    return (
        <>
            <div className='pari-passu-header'>
                <h3 className="chart-title">{t('pari_passu').toUpperCase()}</h3>
                <h3 className='chart-subtitle-focus'>{capitalizeFirstLetter(t('deviation'))} {deviationPercent}% = {formatNumber(deviationAmount)} {t('dolar_sign')}</h3>
            </div>
            <table className='pari-passu-content'>
                <thead>
                    <tr className='pari-passu-content-headers'>
                        <th className='header-item'></th>
                        <th className='header-BID'><b>{t('bid')}</b></th>
                        <th className='header-local'><b>{t('local')}</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='pari-passu-content-rows'>
                        <td className='item'><b>{t('contractual')}</b></td>
                        <td className='BID'>{contractualBIDAmount}%</td>
                        <td className='local'>{contractualLocalAmount}%</td>
                    </tr>
                    <tr className='pari-passu-content-rows'>
                        <td className='item'><b>{t('current_year')}</b></td>
                        <td className='BID'>{currentBIDAmount}%</td>
                        <td className='local'>{currentLocalAmount}%</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

export default PariPassuTable;
